// Strip the stray "30 Days" period label the Trafficly counter appends on this store,
// so it reads like .com/.me: "187 people are currently looking at this product".
(function () {
  var re = /\s*30\s*Days\s*/i;
  function strip() {
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && re.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(re, ' ').replace(/\s+$/, '');
      }
    }
  }
  function init() {
    strip();
    var t;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(strip, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
